import dayjs from 'dayjs';

const LEGACY_PUBLICATION_DATE_REGEX = /^(\d{2})-(\d{2})-(\d{4})$/;

export function parsePublicationDate (publicationDate?: string | null): dayjs.Dayjs | null {
    const trimmedDate = publicationDate?.trim();
    if (!trimmedDate) return null;

    const legacyDate = parseLegacyPublicationDate(trimmedDate);
    if (legacyDate) return legacyDate;

    const parsedDate = dayjs(trimmedDate);
    return parsedDate.isValid() ? parsedDate : null;
}

export function getPublicationDateTimestamp (publicationDate?: string | null): number {
    return parsePublicationDate(publicationDate)?.valueOf() ?? 0;
}

export function formatPublicationDateForDisplay (publicationDate?: string | null, format = 'DD MMM YYYY'): string {
    return parsePublicationDate(publicationDate)?.format(format) ?? '';
}

export function serializePublicationDateForSave (date: Date | null): string {
    return dayjs(date ?? new Date()).toISOString();
}

export function isPublicationDateInFuture (publicationDate: string | null): boolean {
    const parsedDate = parsePublicationDate(publicationDate);
    return parsedDate ? parsedDate.isAfter(dayjs()) : false;
}

function parseLegacyPublicationDate (publicationDate: string): dayjs.Dayjs | null {
    const match = LEGACY_PUBLICATION_DATE_REGEX.exec(publicationDate);
    if (!match) return null;

    const [, day, month, year] = match;
    const parsedDate = dayjs(`${year}-${month}-${day}T00:00:00`);
    return parsedDate.isValid() ? parsedDate : null;
}
